export const environment = {
  production: false,
  API_BASE_PATH: 'https://dev-private-api.dreampay.com.br',
  apiKey: '8edVQyVI35xjmKB4DVIhdiEAW0LTLRLY',
  SENTRY_DSN: '',
  appVersion: '1.0.0',
  buildNumber: '1',
  enablePrepaidCards: true,
  appDomain: 'https://dev-app.dreampay.com.br',
};
